import { Component, Input, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss']
})
export class CounterComponent implements OnInit {


  @Input("displayCount") displayCount = 1
  @Output() count: EventEmitter<number> = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void {
  }


  incrementCount() {
    this.displayCount++;
    this.count.emit(this.displayCount)
  }

  decrementCount() {
    if (this.displayCount >0) {
      this.displayCount--;
      this.count.emit(this.displayCount)
    }
  }

}
